import { MessageChannel } from "config/CustomEnums";
import {
  secondEmailStepValidate,
  secondPushStepValidate,
  secondSmsStepValidate,
  secondWhatsappStepValidate
} from "../message/CreateMessageValidate";

export const recurringMessageValidate = ({ getValues, errorList }) => {
  const [
    recurringMessage,
    channels,
  ] = getValues([
    "recurringMessage",
    "recurringMessage.channels",
  ]);
  console.log("@@29", recurringMessage);

  if (channels && channels?.length > 0) {
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.pushAndInbox)
      || channels?.includes(MessageChannel.push)
      || channels?.includes(MessageChannel.inbox)
    ) {
      const pushValidate = secondPushStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!pushValidate) {
        errorList.push({
          name: `recurringMessage.channel.${MessageChannel.pushAndInbox}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.email)
    ) {
      const emailValidate = secondEmailStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!emailValidate) {
        errorList.push({
          name: `recurringMessage.channel.${MessageChannel.email}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.sms)
    ) {
      const smsValidate = secondSmsStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!smsValidate) {
        errorList.push({
          name: `recurringMessage.channel.${MessageChannel.sms}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.whatsapp)
    ) {
      const whatsappValidate = secondWhatsappStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!whatsappValidate) {
        errorList.push({
          name: `recurringMessage.channel.${MessageChannel.whatsapp}`,
          message: "have errors inside",
        })
      }
    };
  }
};
